import { type CSSProperties } from 'react';

import { COLOR_RED, FONT_INTER } from './blueprint-view-styles';

export const PANEL_FOOTER_OUTER_STYLE: CSSProperties = {
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'stretch',
	gap: '14px',
	marginTop: '14px',
	fontFamily: FONT_INTER
};

export const PANEL_FOOTER_NOTES_STYLE: CSSProperties = {
	backgroundColor: '#eee',
	border: '1px solid #000',
	lineHeight: 1.5,
	width: '70%',
	padding: '14px'
};

export const PANEL_FOOTER_NOTES_HEADING_STYLE: CSSProperties = {
	color: COLOR_RED,
	fontWeight: 700,
	fontFamily: FONT_INTER,
	textTransform: 'uppercase',
	textAlign: 'center',
	marginBottom: '7px'
};

export const PANEL_FOOTER_NOTE_ITEM_STYLE: CSSProperties = {
	color: COLOR_RED
};
